import { X } from "lucide-react";
import { Badge } from "../primitives/badge";

/**
 * One removable chip in an active-filter bar — the on-page residue of one
 * applied filter value. `CustomerScopeChip` is this same shape specialised
 * for the customer-scope case (kept separate because its label always reads
 * "Customer: <name>" and its dismiss aria-label is customer-specific); every
 * other filter chip on a list page should use this directly rather than
 * hand-rolling the badge+button markup again.
 */
export function FilterChip({
  label,
  onDismiss,
  dismissLabel,
}: {
  label: React.ReactNode;
  onDismiss: () => void;
  /** aria-label for the dismiss button. Defaults to "Remove filter". */
  dismissLabel?: string;
}) {
  return (
    <Badge variant="secondary" className="gap-1 pr-1 text-sm font-normal h-7">
      <span>{label}</span>
      <button
        onClick={onDismiss}
        className="ml-0.5 rounded-sm hover:bg-muted transition-colors p-0.5"
        aria-label={dismissLabel ?? "Remove filter"}
      >
        <X className="size-3" />
      </button>
    </Badge>
  );
}
